import React from "react";

import { Header } from "../../components/headers/header/header.component";

export const WorkOrderListHeader = () => {
  return <Header title="Brief Work Orders" />;
};
